import { Component, OnInit } from '@angular/core';
import { BeneficiariosService } from 'app/services/beneficiarios.service';
import { TitularesService } from 'app/services/titulares.service';
import { PrioridadesService } from 'app/services/prioridades.service';

@Component({
  selector: 'app-consultar-usuario',
  templateUrl: './consultar-usuario.component.html',
  styleUrls: ['./consultar-usuario.component.scss']
})
export class ConsultarUsuarioComponent implements OnInit {

  dataSource:any;
  displayedColumns: string[] = [
    'Tipo',
    'PS', 
    'Tipo',
    'TS', 
    'Meses',
    'Doc', 
    'Nombre', 
    'SAT', 
    'PSM', 
    'Radicado', 
    'Ingreso', 
    'Tel', 
    'Cel', 
    'Retiros', 
    'Activo', 
    'Edad',
  ];

  documento:number;
  radicado:number;
  rangosPrioridad;

  constructor(
    private benService:BeneficiariosService, 
    private titService:TitularesService,
    private prioridades:PrioridadesService
  ) { }

  ngOnInit() {
    this.prioridades.prioridades().then(data=>{
      this.rangosPrioridad = data;
      console.log(this.rangosPrioridad);
    });
  }

  buscarBeneficiario() {

    console.log(this.documento);
    this.benService.totalServiciosBeneficiario(this.documento).subscribe(
      data=>{
        console.log("beneficiario: ", data);
        this.dataSource = data;
        this.dataSource[0].bening = new Date(this.dataSource[0].bening).toLocaleDateString();

        this.benService.totalMeses(this.dataSource[0].ID_Ben).then(
          data=>{
            console.log("test");
            this.dataSource[0].meses = data;
            //PS
            this.dataSource[0].ps = ((this.dataSource[0].total_servicios * 100) / (0.25 * this.dataSource[0].meses)).toFixed(1);
            console.log(this.dataSource[0].total_servicios, this.dataSource[0].meses);

            let prioridad;
              //Si tiene estado ApoyoVip 1 en la base de datos tendrá prioridad VIP
              if (this.dataSource[0].ID_Titular.ApoyoVip == 1) {
                prioridad = "VIP";
              } else if (this.dataSource[0].ID_Titular == 7477) {
                //La asociación viva cerritos se toma como prioridad APE
                prioridad = "APE";
              } else if (this.dataSource[0].bencba == 15) {
                //Las cortesías tienen prioridad COR
                prioridad = "COR";
              } else {
                //Si el beneficiario solo tiene un servicio y lleva menos de 6 meses
                //Siempre será prioridad 2
                if (this.dataSource[0].total_servicios == "1" && this.dataSource[0].meses <= 6) {
                  prioridad = "2";
                } else {
                  //Dependiendo el promedio del contrato
                  //se determina la prioridad del servicio
                  if (this.dataSource[0].ps < this.rangosPrioridad[0].rango_final) {
                    prioridad = this.rangosPrioridad[0].prioridad;
                  } else if(this.dataSource[0].ps < this.rangosPrioridad[1].rango_final) {
                    prioridad = this.rangosPrioridad[1].prioridad;
                  } else if(this.dataSource[0].ps < this.rangosPrioridad[2].rango_final) {
                    prioridad = this.rangosPrioridad[2].prioridad;
                  } else if(this.dataSource[0].ps < this.rangosPrioridad[3].rango_final) {
                    prioridad = this.rangosPrioridad[3].prioridad;
                  } else if(this.dataSource[0].ps < this.rangosPrioridad[4].rango_final) {
                    prioridad = this.rangosPrioridad[4].prioridad;
                  } else {
                    prioridad = "5";
                  }

                }
              }
              this.dataSource[0].prioridad = prioridad;

            //SAT
            this.dataSource[0].sat = (0.25 * this.dataSource[0].meses);
          }
        );
      }
    );

  }

  async buscarBeneficiarioRadicado() {

    console.log(this.documento);
    await this.benService.totalServiciosBeneficiarioRadicado(this.radicado).subscribe(
      async data=>{
        console.log("beneficiario: ", data);        
        this.dataSource = data;        

        for (let i = 0; i < this.dataSource.length; i++) {
          const fila = this.dataSource[i];
          fila.bening = new Date(fila.bening).toLocaleDateString();
          await this.benService.totalMeses(fila.ID_Ben).then(
            data=>{
              fila.meses = data;
              //PS
              fila.ps = ((fila.total_servicios * 100) / (0.25 * fila.meses)).toFixed(1);
              console.log(fila.total_servicios, fila.meses);

              let prioridad;
              //Si tiene estado ApoyoVip 1 en la base de datos tendrá prioridad VIP
              if (fila.ID_Titular.ApoyoVip == 1) {
                prioridad = "VIP";
              } else if (fila.ID_Titular == 7477) {
                //La asociación viva cerritos se toma como prioridad APE
                prioridad = "APE";
              } else if (fila.bencba == 15) {
                //Las cortesías tienen prioridad COR
                prioridad = "COR";
              } else {
                //Si el beneficiario solo tiene un servicio y lleva menos de 6 meses
                //Siempre será prioridad 2
                if (fila.total_servicios == "1" && fila.meses <= 6) {
                  prioridad = "2";
                } else {
                  //Dependiendo el promedio del contrato
                  //se determina la prioridad del servicio
                  if (fila.ps < this.rangosPrioridad[0].rango_final) {
                    prioridad = this.rangosPrioridad[0].prioridad;
                  } else if(fila.ps < this.rangosPrioridad[1].rango_final) {
                    prioridad = this.rangosPrioridad[1].prioridad;
                  } else if(fila.ps < this.rangosPrioridad[2].rango_final) {
                    prioridad = this.rangosPrioridad[2].prioridad;
                  } else if(fila.ps < this.rangosPrioridad[3].rango_final) {
                    prioridad = this.rangosPrioridad[3].prioridad;
                  } else if(fila.ps < this.rangosPrioridad[4].rango_final) {
                    prioridad = this.rangosPrioridad[4].prioridad;
                  } else {
                    prioridad = "5";
                  }

                }
              }
              fila.prioridad = prioridad;

              //SAT
              fila.sat = (0.25 * fila.meses);
              
              //this.consultarTitular(i, fila.ID_Titular);
            }
          );
        }        

      }
    );

  }

  verificarActivo(bencba):string {
    let activo;

    if(bencba == 0 || bencba == 15) {
      activo = "Activo";
    } else {
      activo = "Inactivo";
    }

    return activo;
  }

}

class serBen {
  ApoyoUsuario: number;
  ID_Ben: number;
  ID_Grupo: number;
  ID_Titular: number;
  PerTiempoBen: number;
  bencel: string;
  bendoc: string;
  bening: string;
  bennom: string;
  bentel: string;
  edad: number;
  grugru: string;
  id_grupo: number;
  promeServAde: number;
  psm: number;
  retiros: number;
  servAdeTotal: number;
  total_servicios: number;
  meses:any;
  ps:any;
  sat:any;
}
